import { DefaultSet as GQLItem } from '../../../generated/api.graphql';

export type EventDefaults = {
  footerContent?: string;
  orderConfirmationContent?: string;
  confirmationEmailContent?: string;
  availableForSalesTax?: boolean;
  availableForProcessingFee?: boolean;
  mailPdfTickets?: boolean;
  availableForDonation?: boolean;
  minimumAge?: number;
  ticketLimit?: number;
  startTime?: string;
  doorTime?: string;
  endTime?: string;
};

export type Defaults = {
  event?: EventDefaults;
};

export type DefaultSet = {
  id: number;
  defaults: Defaults;
};

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};

export const fromGql = (item: GQLItem): DefaultSet => {
  const raw = isPlainObject(item.defaults) ? item.defaults : {};
  const event = isPlainObject(raw.event) ? (raw.event as EventDefaults) : undefined;
  return {
    id: item.id,
    defaults: event ? { event } : {},
  };
};
